import { cn } from '@/lib/utils'
import {
  AccordionSection,
  type AccordionSectionProps,
} from './accordion-section'

type Props = {
  className?: string
  sections: AccordionSectionProps[]
}

export const AccordionBanner = ({ className, sections }: Props) => {
  if (sections.length === 0) return null

  return (
    <div className={cn('space-y-3', className)}>
      {sections.map(section => (
        <AccordionSection key={section.id} {...section} />
      ))}
    </div>
  )
}
